import { render } from "./ProductsRequestEndPage.vue?vue&type=template&id=eff91cec"
import script from "./ProductsRequestEndPage.vue?vue&type=script&lang=js"
export * from "./ProductsRequestEndPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__